import { preloadableData } from '@/lib/preloadable';
import type { Beruf } from './types';

/** Jede Berufsseite ist ein eigener Chunk und wird erst beim Aufruf geladen. */
const DATEN: Record<string, ReturnType<typeof preloadableData<Beruf>>> = Object.fromEntries(
  Object.entries({
    'ki-engineer': () => import('./ki-engineer'),
    'product-manager': () => import('./product-manager'),
    'cto': () => import('./cto'),
    'frontend-developer': () => import('./frontend-developer'),
    'backend-developer': () => import('./backend-developer'),
    'devops-cloud-engineer': () => import('./devops-cloud-engineer'),
    'mobile-developer': () => import('./mobile-developer'),
    'data-scientist': () => import('./data-scientist'),
    'it-security-specialist': () => import('./it-security-specialist'),
    'ui-ux-designer': () => import('./ui-ux-designer'),
    'agile-coach-scrum-master': () => import('./agile-coach-scrum-master'),
    'system-administrator': () => import('./system-administrator'),
  }).map(([slug, load]) => [slug, preloadableData(() => load().then((m) => m.default))]),
);

export const hatBeruf = (slug: string) => slug in DATEN;
export const preloadBeruf = (slug: string) => DATEN[slug]?.preload() ?? Promise.resolve();
export const preloadAlleBerufe = () => Promise.all(Object.values(DATEN).map((d) => d.preload()));
/** Liefert die vollständigen Daten oder suspendiert, bis sie geladen sind. */
export const useBeruf = (slug: string): Beruf | undefined => DATEN[slug]?.read();
